import { useEffect, useRef } from "react"

export const useInitialSelectedId = ({ items, selectedKey = "is_selected", idKey = "id" }) => {
  const initialSelectedId = useRef(null)

  useEffect(() => {
    if (!initialSelectedId.current && Array.isArray(items)) {
      const selectedItem = items.find((item) => item[selectedKey])
      if (selectedItem && selectedItem[idKey] != null) {
        initialSelectedId.current = selectedItem[idKey]
      }
    }
  }, [items, selectedKey, idKey])

  return initialSelectedId
}
